import { render, staticRenderFns } from "./dispatch2dy.vue?vue&type=template&id=77789f03&scoped=true"
import script from "./dispatch2dy.vue?vue&type=script&lang=js"
export * from "./dispatch2dy.vue?vue&type=script&lang=js"
import style0 from "./dispatch2dy.vue?vue&type=style&index=0&id=77789f03&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77789f03",
  null
  
)

export default component.exports